<template>
  <div class="content">
    <div>
      <h4>步骤1</h4>
      <p>在微信，百度网盘或文件管理器中 打开文件的分享(不支持jpg和png格式)</p>
      <div>
        <img :src="step1" alt="" />
      </div>
    </div>
    <div>
      <h4>步骤2</h4>
      <p>选择【在其他应用打开】-【更多】打开【世界农场】开关</p>
      <div>
        <img :src="step2" alt="" />
      </div>
    </div>
    <div>
      <h4>步骤3</h4>
      <p>回到【在其他应用打开】，用【世界农场】打开</p>
      <div>
        <img :src="step3" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
import step1 from "@/assets/guide/1.png";
import step2 from "@/assets/guide/2.png";
import step3 from "@/assets/guide/3.png";

export default {
  data() {
    return {
      step1,
      step2,
      step3
    };
  }
};
</script>

<style lang="postcss" scoped>
.content {
  width: 90%;
  padding: 24px 0;
  margin: 0 auto;
  text-align: center;
}
h4 {
  font-size: 20px;
  padding-bottom: 12px;
}
p {
  font-size: 16px;
  line-height: 23px;
  padding-bottom: 24px;
}
h4,
p {
  color: #2b2c2e;
  text-align: center;
}
img {
  vertical-align: top;
  padding-bottom: 32px;
  width: 100%;
}
</style>
